import React from 'react';
import withRouteHelpers from 'common/hoc/withRouteHelpers';
import ProjectTemplateAutoAssignmentRuleSelect from './ProjectTemplateAutoAssignmentRuleSelect';
import useDepartments from 'common/hooks/useDepartments';

const ProjectTemplateAutoAssignmentRuleDepartmentSelect = props => {
  const {
    className,
    'data-test-id': dataTestId,
    departmentId,
    onChange,
    projectId,
  } = props;
  const { data: departments, loading } = useDepartments({ projectId });
  const departmentOptions = departments?.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
  return (
    <ProjectTemplateAutoAssignmentRuleSelect
      label="Department"
      isLoading={loading}
      options={departmentOptions}
      value={departmentId}
      onChange={departmentId =>
        onChange(departments.find(({ id }) => id === departmentId))
      }
      data-test-id={dataTestId}
      className={className}
    />
  );
};

export default withRouteHelpers(
  ProjectTemplateAutoAssignmentRuleDepartmentSelect,
);
